import { useCurrentUser } from '@/hooks';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useEffect } from 'react';

function RouteComponent() {
	const { logUserOut } = useCurrentUser();

	useEffect(() => {
		logUserOut();
	}, [logUserOut]);

	return <Navigate to="/welcome" />;
}

export const Route = createFileRoute('/auth/logout')({
	component: RouteComponent,
});
